import * as auditoriaTypes from "../types/auditoria";

const initState = {
  idAuditoria: null,
  idAuditoriaDet: [],
};

export default (state = initState, action) => {
  switch (action.type) {
    case auditoriaTypes.SEND_AUDITORIA:
      return {
        ...state,
        idAuditoria: action.data,
        error: null,
      };
    case auditoriaTypes.SEND_AUDITORIA_DETALLE:
      return {
        ...state,
        idAuditoriaDet: [...state.idAuditoriaDet, action.data],
        error: null,
      };

    default:
      return state;
  }
};



